export const ieo = {
    "zzjx": "진행 중",
    "rgjl": "구독 기록",
    "yjjs": "종료됨",
    "sf": "최초",
    "mjze": "모금 총액",
    "ckjz": "모금 진행",
    "tips_1": "Biking Startup 플랫폼이 출시되었습니다. 함께 재정 비밀을 발굴하세요!",
    "tips_2": "고품질 프로젝트가 곧 출시됩니다. 기대해 주세요.",
    "jyjjks": "거래가 곧 시작됩니다",
    "ksjy": "거래 시작",
    "qjy": "거래하러 가기",
    "xmmc": "프로젝트명",
    "xmfjs": "프로젝트 소개",
    "syxm": "모든 프로젝트",
    "banner_1": "블록체인 프로젝트 최초 발매 플랫폼 신규 출시",
    "banner_2": "Biking함께 블록체인의 다크호스를 찾고 부의 자유를 향한 길을 시작해 보세요",
    "ywc": "완료됨",
    "rgsj": "구독 시간:",
    "zcz": "지지자",
    "dqjd": "현재 진행 상황",
    "yck": "모금 완료",
    "sddb": "대체 수령",
    "dff": "발행 대기",
    "zwxm": "프로젝트 없음",
    "xq": "상세 정보",
    "wksyr": "사전 예열 안됨",
    "yrz": "예열 중",
    "jxz": "진행 중",
    "yjs": "종료됨",
    "ts": "팁",
    "dbwfjy": "해당 토큰은 현재 거래할 수 없습니다",
    "ckqtdb": "다른 토큰을 확인하세요",
    "xm": "프로젝트",
    "ksrg": "구독 시작",
    "yrg": "구독됨",
    "xmjs": "프로젝트 소개",
    "csjg": "초기 가격",
    "dbzl": "토큰 총량: {amount} 개",
    "cssz": "초기 시가: {fdv} 미국 달러",
    "xmcytj": "프로젝트 참여 조건",
    "cjygzh": "Biking 계정 만들기",
    "yyzh": "계정이 이미 있습니다. 바로 로그인하세요",
    "dlzhjkcy": "로그인하여 구독할 수 있습니다",
    "dljkrg": "로그인하여 구독할 수 있습니다",
    "xhzc": "현물 자산",
    "zcdy": "현물 자산 ≥ 10 USDT",
    "rggz": "구독 규칙",
    "rgcg": "구독 성공",
    "cgrgxm": "축하합니다! 프로젝트 구독에 성공했습니다!",
    "fhsy": "홈으로 돌아가기",
    "cyrghd": "Biking Startup 구독 활동에 참여하기",
    "rgje": "구독 금액",
    "xhzcgz": "현물 자산 평가 금액",
    "rgsm": "구독 설명:",
    "rgsm1": "1. 개인 구독 금액은 ≥{amount1} USDT여야 합니다; ≤{amount2} USDT;",
    "rgsm2": "2. 프로젝트는 자금 투입 비율에 따라 구독을 동일한 비율로 분배하며, 사용자의 구독 금액이 실제로 할당된 토큰 금액보다 큰 경우, 구독 종료 후 잔여 U가 현금 계정으로 반환됩니다.",
    "qd": "확인",
    "dyr": "예열 중",
    "rgdjs": "구독 카운트 다운",
    "yrdjs": "예열 카운트 다운",
    "jykqdjs": "거래 개시 카운트 다운",
    "qrg": "구독하러 가기",
    "rgjebdy": "구독 금액은 최소 {amount} USDT 이상이어야 합니다",
    "rgjebgy": "구독 금액은 최대 {amount} USDT를 초과할 수 없습니다",
    "rgjeccdqjc": "현재 자산 금액을 초과하는 구독 금액입니다",
    "fxts1": "1. 초기 프로젝트는 여전히 초기 단계에 있으며, 프로젝트 운영, 프로젝트의 기본 기술, 법률 및 규정 환경 등에는 매우 큰 위험이 있을 수 있습니다.",
    "fxts2": "2. Token을 이해하고 그에 대한 고유한 위험을 평가하기 위해서는 고급 기술 및 금융 지식이 필요합니다.",
    "fxts3": "3. 기술, 법률 및 규정, 시장 및 기타 요인의 영향을 받아 구매한 Token의 가격이 급격하게 변동할 수 있으며, 가격이 크게 하락하거나 상승할 수 있습니다.",
    "fxts4": "4. Token의 기본 기술이나 BIKING 거래 플랫폼의 이유로 구매한 Token을 전부 또는 일부 인출할 수 없을 수 있습니다.",
    "sfpt": "블록체인 프로젝트 최초 발매 플랫폼",
    "xmhzsq": "프로젝트 협력 신청",
    hdlx: "활동 유형",
    yryq: "하나의 기호",
    yrdq: "다중 서명",
    hdjg: "활동 가격",
    hdsl: "활동 수",
    zqs: "총 서명 수",
    rgqs: "구독 티켓 수",
    rgsl: "구독 수량",
    mqsl: "서명당 수량",
    mrzgqs: "최대 서명 수",
    qian: "서명",
    lian: "체인",
    hdrgsm: "구독 안내: 복권 당첨 후, 당첨된 총 사용자 수는 당첨된 모든 사용자를 기준으로 무작위로 선택됩니다. 구독이 실패할 경우 당첨 에어드랍이 발행될 때 실패한 구독에 사용된 USDT가 반환됩니다." ,
    jqqd: "승리 결과를 기대합니다",
    dbffkjy: "토큰은 발행된 후 거래될 수 있습니다",
    dzjgb: "발표 예정",
    dzq: "승리",
    ffzt: "배포 상태",
    dbff: "승리 토큰 발행",
    yff: "이미 보상됨",
    wzq: "승리하지 못함",
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/ieo/kr.js